export default __webpack_public_path__ + "static/media/sea.83995331.svg";